<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- 灰名单设置 -->
        <el-tab-pane>
          <span slot="label">{{ $t("logs.tempalte_adm") }}</span>
          <div class="main" v-show="this.show_temloate_table == 1">
            <el-button
              @click="add_template"
              :disabled="$root.jurisdiction.only_query == 0"
              >{{ $t("logs.tempalte_adm_add") }}
            </el-button>
          </div>
          <div class="switch1">
            <div
              class="table table02 table_hover"
              v-show="this.show_temloate_table == 1"
            >
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_template"
                v-loading="loading"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="44"
                >
                </el-table-column>
                <el-table-column
                  prop="TEMPLATE_NAME"
                  :label="$t('logs.Policy_comb1')"
                  width="100"
                >
                </el-table-column>

                <el-table-column
                  prop="DESCRIPTION"
                  :label="$t('logs.Policy_unit5')"
                >
                </el-table-column>
                <el-table-column
                  prop="NOTIFY_ENVFROM"
                  :label="$t('logs.Policy_unit_sender1')"
                >
                </el-table-column>
                <el-table-column
                  prop="NOTIFY_SUBJECT"
                  :label="$t('logs.tempalte_adm_notify')"
                >
                </el-table-column>

                <el-table-column
                  prop="NOTIFY_BODY_TEMPALTE"
                  :label="$t('logs.tempalte_adm_content')"
                >
                </el-table-column>
                <el-table-column
                  prop=""
                  :label="$t('table1.operation')"
                  width="130"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                    <!-- 编辑 -->

                    <el-button
                      :disabled="$root.jurisdiction.only_query == 0"
                      type="text"
                      size="small"
                      @click="unit_edit(scope.$index, scope.row)"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                   
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 增加和编辑 -->
            <div class="lie lie_add_role" v-if="this.add_temloate_table == 1">
              <div
                class="create_information"
                v-if="this.temloate_edit_table == 0"
              >
                {{ $t("logs.tempalte_adm_add") }}
              </div>
              <div
                class="create_information"
                v-if="this.temloate_edit_table == 1"
              >
                {{ $t("logs.tempalte_adm_edit") }}
              </div>
              <table>
                <tbody>
                  <!-- 模板名称-->
                  <tr>
                    <td>{{ $t("logs.tempalte_adm_name") }}:</td>
                    <td>
                      <el-input v-model="template_name" clearable  v-show="this.temloate_edit_table == 0"></el-input>
                       <p
                      v-show="this.temloate_edit_table == 1"
                      style="
                        text-align: left;
                        color: #0e2c5e;
                        margin: 8px 0px;
                        border-bottom: 0;
                       
                      "
                    >
                      {{ this.template_name }}
                    </p>
                    </td>
                  </tr>
                  <!-- 备注说明-->
                  <tr>
                    <td>{{ $t("logs.Policy_unit5") }}:</td>
                    <td>
                      <el-input
                        v-model="description"
                        placeholder=""
                        clearable
                      ></el-input>
                    </td>
                  </tr>
                  <!-- 发件人-->
                  <tr>
                    <td>{{ $t("logs.Policy_unit_sender1") }}:</td>
                    <td>
                      <el-input v-model="notify_envfrom" clearable></el-input>
                    </td>
                  </tr>
                  <!-- 通知主题-->
                  <tr>
                    <td>{{ $t("logs.tempalte_adm_notify") }}:</td>
                    <td>
                      <el-input v-model="notify_subject" clearable></el-input>
                    </td>
                  </tr>
                  <!-- 通知内容-->
                  <tr>
                    <td>{{ $t("logs.tempalte_adm_content") }}:</td>
                    <td style="width: 60%">
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 8 }"
                        placeholder="请输入内容"
                        v-model="notify_body_template"
                      >
                      </el-input>
                    </td>
                  </tr>

                  <!-- 原邮件作为附件-->
                  <tr>
                    <td>{{ $t("logs.tempalte_adm_acc") }}:</td>
                    <td>
                      <el-checkbox
                        v-model="notify_inc_eml"
                        style="padding: 12px 0"
                      ></el-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td style="display: flex; flex-direction: row">
                      <el-button
                        type="primary"
                        @click="save_gray()"
                        :disabled="$root.jurisdiction.only_query == 0"
                        >{{ $t("logs.save_a") }}</el-button
                      >
                      <el-button
                        type="danger"
                        @click="cancel_gray()"
                        :disabled="$root.jurisdiction.only_query == 0"
                        >{{ $t("logs.save_b") }}</el-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
        loading:false,
      temloate_edit_table: 0,
      show_temloate_table: 1,
      add_temloate_table: 0,
      notify_envfrom: "",
      notify_subject: "",
      notify_body_template: "",
      notify_inc_eml: true,
      description: "",
      template_name: "",

      grey_check: false,
      grey_connect_timeout: "",
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",
      fileList_template: [],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",
      fileList: [],
      radio: [],
      data_loadok1: "",
      edit_id: "",
    };
  },
  mounted() {
    this.getFileList1();
  },
  methods: {
    // 过滤单元编辑
    unit_edit(index, scope) {
      console.log(scope);
      this.show_temloate_table = 0;
      this.add_temloate_table = 1;
      this.temloate_edit_table = 1;
      this.edit_id = scope.ID;
      this.notify_inc_eml = scope.NOTIFY_INC_EML == 1 ? true : false;

      this.notify_envfrom = scope.NOTIFY_ENVFROM;
      this.notify_subject = scope.NOTIFY_SUBJECT;
      this.notify_body_template = scope.NOTIFY_BODY_TEMPALTE;
      this.description = scope.DESCRIPTION;
      this.template_name = scope.TEMPLATE_NAME;
    },
    // 过滤单元删除
    handleClick1(index, scope) {
      console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
         
          let str = this.$qs.stringify({
            __mode: "del_notify_template",
            sid: sid,
            template_name: scope.TEMPALTE_NAME,
          });

          this.$axios.post("/api/adm/cgi/bspam.cgi", str).then((res) => {
            console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList1();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    //   添加
    add_template() {
      this.show_temloate_table = 0;
      this.add_temloate_table = 1;
      this.temloate_edit_table = 0;
      this.notify_inc_eml = false;
      this.edit_id = "";
      this.notify_envfrom = "";
      this.notify_subject = "";
      this.notify_body_template = "";
      this.description = "";
      this.template_name = "";
    },
    cancel_gray() {
      this.show_temloate_table = 1;
      this.add_temloate_table = 0;
    },
    // 保存
    save_gray() {
      // this.loading = true;
      // this.tanchu = false
      this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_notify_template",
        sid: sid,
        id: this.edit_id,

        notify_inc_eml: this.notify_inc_eml == true ? 1 : 0,
        notify_envfrom: this.notify_envfrom,
        notify_subject: this.notify_subject,
        notify_body_template: this.notify_body_template,

        description: this.description,
        template_name: this.template_name,
      });
      this.$axios
        .post(
          "/api/adm/cgi/bspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          this.$close_hint_test();
          // console.log(res);
          this.loading = false;

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
             this.$message({
                                type: "error",
                                message: `${res.data.fmstatus.errmsg}`,
                            });
          } else if (res.data.fmstatus.code == "3") {
            this.$message({
                                type: "error",
                                message: `${res.data.fmstatus.errmsg}`,
                            });
            this.$router.push({
              name: "login",
            });
          } else {
                this.show_temloate_table = 1;
      this.add_temloate_table = 0;
     
            this.getFileList1();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 过滤单元加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/bspam.cgi", {
          params: {
            __mode: "load_notify_template",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);
          this.loading = false;

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.data_loadok1 = res.data.ret.ok;

            this.fileList_template = res.data.ret.datalist;
          }
        });
    },
    // 显示
    tan: function () {
      this.tanchu = true;
    },
    // 打开关闭
    tanSend: function () {
      this.tanchu = false;
    },
    tanOff: function () {
      this.tanchu = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/lie_add_role.less";

/deep/ .el-tabs__nav {
  padding-left: 14px;
}
/deep/ .el-input__suffix {
  margin-right: 10px;
}
</style>
